import { Helmet } from "react-helmet-async";

export default function SEO({
  title,
  description,
  canonical,
  image,
  keywords,
faq = [],
}) {
  return (
    <Helmet prioritizeSeoTags>

      {/* TITLE */}
      <title>{title}</title>

      {/* META DESCRIPTION */}
      <meta
        name="description"
        content={description}
      />

      {/* KEYWORDS */}
      <meta
        name="keywords"
        content={keywords}
      />

      {/* CANONICAL */}


<link
  rel="canonical"
  href={canonical}
/>

<meta
  property="og:url"
  content={canonical}
/>

      {/* OPEN GRAPH */}
      <meta property="og:type" content="website" />
<meta property="fb:app_id" content="1234567890" />
      <meta
        property="og:title"
        content={title}
      />

      <meta
        property="og:description"
        content={description}
      />

      <meta
        property="og:url"
        content={canonical}
      />

      <meta
        property="og:image"
        content={image}
      />

<meta property="og:image:width" content="1200" />
<meta property="og:image:height" content="630" />
<meta property="og:image:type" content="image/jpeg" />

      {/* TWITTER */}
      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content={title}
      />

      <meta
        name="twitter:description"
        content={description}
      />

      <meta
        name="twitter:image"
        content={image}
      />
      <meta
  name="twitter:image:alt"
  content={title}
/>

{/* JSON-LD STRUCTURED DATA */}
<script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "QrMenu Italia",
    url: "https://qrmenu-italia.it",
    logo: image,
    description:
      "Menu digitale QR Code con AI per ristoranti, pizzerie, pub e locali.",
  })}
</script>

<script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "QrMenu Italia",
    url: "https://qrmenu-italia.it",
    potentialAction: {
      "@type": "SearchAction",
      target:
        "https://qrmenu-italia.it/?s={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  })}
</script>

<script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "QrMenu Italia",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web, iOS, Android",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "EUR",
    },
    description,
    url: canonical,
    image,
  })}
</script>

{faq.length > 0 && (
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faq.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.answer,
        },
      })),
    })}
  </script>
)}

    </Helmet>
  );
}